import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";

const saveLogo = {
    namespaced: true,
    state: {
        savingLogo: false,
        modalDataLogoSave: {},
        isLogoSave: false
    },
    mutations: {
        SAVE_LOGO_SUCCESS(state, response) {
            let result = response.result;
            let layout = response.layout;
            let companyData = result.data.data.companyData;
            state.modalDataLogoSave.typeInfoLogoSave = "success";
            state.modalDataLogoSave.headInfoLogoSave = result.data.message;
            state.modalDataLogoSave.textInfoLogoSave = result.data.data.textInfo;
            state.isLogoSave = true;
            if(layout !== "edit") {
                localStorage.setItem("companyFirstName", companyData.firstName);
                localStorage.setItem("companyLastName", companyData.lastName);
                localStorage.setItem("companyName", companyData.companyName);
                localStorage.setItem("companyLogo", companyData.logo);
                eventBus.$emit("updateMyCompany");
            } else {
                eventBus.$emit("updateLogoCompany", companyData.logo);
            }
        },
        SAVE_LOGO_FAILURE(state, error) {
            state.modalDataLogoSave.typeInfoLogoSave = "error";
            state.modalDataLogoSave.textInfoLogoSave = error.response.data.data.message;
            state.modalDataLogoSave.headInfoLogoSave = error.response.data.message;
            state.isLogoSave = true;
        },
        UPDATE_VISIBLE_MODAL_LOGO_SAVE(state, value) {
            state.isLogoSave = value;
        }
    },
    actions: {
        saveLogo: function( { dispatch, state }, payload) {
            state.savingLogo = true;
            let url = new URL(window.location.href);
            let formData = new FormData();
            formData.append("logo", payload.creds.logo);
            formData.append("companyId", url.searchParams.get("companyId"));
            let promise = sendRequest("post", config.baseURLApi + "/companies/logo", {}, formData);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successSaveLogo", {result: result[1], layout: payload.creds.layout});
                } else {
                    dispatch("failureSaveLogo", result[1]);
                }
                state.savingLogo = false;
            });
        },
        successSaveLogo: function({ commit }, response) {
            commit("SAVE_LOGO_SUCCESS", response);
        },
        failureSaveLogo: function({ commit }, error) {
            commit("SAVE_LOGO_FAILURE", error);
        },
        updateVisibleModalLogoSave({ commit }, value) {
            commit("UPDATE_VISIBLE_MODAL_LOGO_SAVE", value);
        }
    }
}

export default saveLogo;